/**
 * @generated SignedSource<<fc58c955f3bf23dc2cf8c9246d3d15b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SkillCluster_toolCall$data = {
  readonly toolUse: {
    readonly id: string;
    readonly input: {
      readonly __typename: "GenericToolInput";
      readonly rawInput: any;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  } | null | undefined;
  readonly " $fragmentType": "SkillCluster_toolCall";
};
export type SkillCluster_toolCall$key = {
  readonly " $data"?: SkillCluster_toolCall$data;
  readonly " $fragmentSpreads": FragmentRefs<"SkillCluster_toolCall">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillCluster_toolCall",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageToolUse",
      "kind": "LinkedField",
      "name": "toolUse",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "input",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rawInput",
                  "storageKey": null
                }
              ],
              "type": "GenericToolInput",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLMessageToolCall",
  "abstractKey": null
};

(node as any).hash = "9493923c0df95c27aee8ee546a79ea40";

export default node;
